import React from "react";
import MaximusSvg from "../../Icons/MaximusSvg";
import UnitySvg from "../../Icons/UnitySvg";
import PnbSvg from "../../Icons/PnbSvg";
import CanaraBankSvg from "../../Icons/CanaraBankSvg";

export default function PartnersComponent() {
  const PartnersImages = [
    { icon: UnitySvg },
    { icon: MaximusSvg },
    { icon: PnbSvg },
    { icon: CanaraBankSvg },
  ];
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Our alliances
            </h3>
            <p className="mt-3 pr-4 max-w-3xl text-sm md:text-lg text-gray-500">
              We are closely associated with various Banks, Financial
              Institutions, ARCs, Liquidators, Insolvency professionals to
              complete and accelerate the entire auction process.
            </p>
          </div>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-2 lg:mt-0 lg:grid-cols-2">
            {PartnersImages.map((item, index) => {
              return (
                <div
                  className="col-span-1 flex justify-center items-center py-8 px-8"
                  key={index}
                >
                  <item.icon />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
